import './ClientResourcesScreen.scss';
import BackComponent from "../../../shared/components/back/BackComponent";
import {useCallback, useState} from "react";
import {useNavigate} from "react-router-dom";
import {CommonService} from "../../../shared/services";
import CardComponent from "../../../shared/components/card/CardComponent";
import ListInfoCardComponent from "../../../shared/components/list-info-card/ListInfoCardComponent";
import LinkComponent from "../../../shared/components/link/LinkComponent";
import ModalComponent from "../../../shared/components/modal/ModalComponent";
import AttendanceAndCancellationPolicyComponent
    from "../../transaction/attendance-and-cancellation-policy/AttendanceAndCancellationPolicyComponent";
import FacilityDetailsComponent from "../../client-cases/facility-details/FacilityDetailsComponent";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import DashboardFormListComponent from "../dashboard-form-list/DashboardFormListComponent";

interface IClientResourcesScreenProps {

}

const ClientResourcesScreen = (props: IClientResourcesScreenProps) => {

    const navigate = useNavigate();
    const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);
    const [isPolicyModalOpen, setIsPolicyModalOpen] = useState(false);
    const {systemSettingsDetails} = useSelector((state: IRootReducerState) => state.user)
    const {clientBasicDetails} = useSelector((state: IRootReducerState) => state.client);

    const navigateToDashboard = useCallback(() => {
        navigate(CommonService._routeConfig.Dashboard())
    }, [navigate]);

    return (
        <div className="client-resources-screen">
            <div className="list-screen__header">
                <div className="list-screen__header-title">
                    <BackComponent onClick={navigateToDashboard}/>
                </div>
                <div className={'contact-number-wrapper'}>
                    <div className={'contact-message'}>For any questions or concerns, please <span
                        onClick={() => setIsContactUsModalOpen(true)}
                        className={'contact-us'}>contact us.</span></div>
                </div>
            </div>
            <CardComponent>
                <div className={'general-info-heading'}>General Documents</div>
                <div className={'ts-row'}>
                    <div className={'ts-col-lg-6 ts-col-md-12 ts-col-sm-12 ts-col-xs-12'}>
                        <ListInfoCardComponent backgroundColor={'#F2FAFF'} value={'Notice of Privacy Practices'}
                                               action={<LinkComponent onClick={() => setIsPolicyModalOpen(true)}>
                                                   View
                                               </LinkComponent>}/>
                    </div>
                    <div className={'ts-col-lg-6 ts-col-md-12 ts-col-sm-12 ts-col-xs-12'}>
                        <ListInfoCardComponent backgroundColor={'#F2FAFF'} value={'Attendance/Cancellation Policy'}
                                               action={<LinkComponent onClick={() => setIsPolicyModalOpen(true)}>
                                                   View
                                               </LinkComponent>}/>
                    </div>
                </div>
            </CardComponent>
            <CardComponent className={'mrg-top-20'}>
                <div className={'general-info-heading'}>Waiver and Authorization Forms</div>
                <div className={'forms-section mrg-bottom-25 '}>
                    <div className={'forms-wrapper'}>
                        <div className={'forms-heading'}>Authorization to Release Health Information</div>
                        <div className={'forms-description'}>The <b>Authorization to Release Protected Health
                            Information</b> form is a legal document
                            that allows you to specify who you authorize us to share your medical records and health
                            information with. This form ensures that the release of your Protected Health Information
                            (PHI) complies with privacy laws in the United States. Please note that this form must be
                            completed for each individual case and will remain valid for one (1) year from the date of
                            signing, unless revoked by written notice.
                        </div>
                        <div className={'forms-button'}>
                            <ButtonComponent variant={'outlined'}
                                             size={'small'}
                                             onClick={() => navigate(CommonService._routeConfig.AddClientHealthReleaseRoute()) + '?mode=add'}
                                             color={'accent'}>Add New Release</ButtonComponent>
                        </div>
                    </div>
                    {systemSettingsDetails?.other_settings?.waiver_enabled &&
                        <div className={'forms-wrapper'}>
                            <div className={'forms-heading'}>Waiver and Release of Liability Form</div>
                            <div className={'forms-description'}>The <b>Waiver and Release of Liability form</b> is a
                                legal
                                agreement required for participation in activities with Kinergy Sports Medicine and
                                Performance. This form remains valid for one (1) year from the date of signing. A new
                                Waiver and Release of Liability must be signed upon the expiration of this form.
                            </div>
                            <div className={'forms-button pdd-top-50'}>
                                <ButtonComponent variant={'outlined'}
                                                 size={'small'}
                                                 disabled={!systemSettingsDetails?.other_settings?.waiver_enabled || clientBasicDetails?.is_waiver_form_filled}
                                                 onClick={() => navigate(CommonService._routeConfig.AddClientWaiverAndReleaseRoute())}
                                                 color={'accent'}>Review and Sign</ButtonComponent>
                            </div>
                        </div>}
                </div>
                <DashboardFormListComponent/>
            </CardComponent>
            <ModalComponent isOpen={isPolicyModalOpen}>
                <AttendanceAndCancellationPolicyComponent isNoticeOfPrivacyPolicyNeeded={true}
                                                          setIsAttendanceModalOpen={setIsPolicyModalOpen}/>
            </ModalComponent>
            <ModalComponent isOpen={isContactUsModalOpen}
                            closeOnBackDropClick={true}
                            modalFooter={<ButtonComponent color={'accent'} className={'mrg-bottom-30 mrg-top-10'}
                                                          onClick={() => setIsContactUsModalOpen(false)}>
                                Close
                            </ButtonComponent>}
                            onClose={() => setIsContactUsModalOpen(false)}>
                <FacilityDetailsComponent title={'Contact Us'}/>

            </ModalComponent>
        </div>
    )
}

export default ClientResourcesScreen;
